import React from 'react'
import { Redirect } from 'react-router'

class LoginPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            checkingUser: false
        }
    }

    componentDidMount() {
        const ga = window.gapi && window.gapi.auth2 ? window.gapi.auth2.getAuthInstance() : null
        if (!ga) this._createScript()

        this.setState({ checkingUser: true }, () => {
            this.props.checkUserSession(() => {
                this.setState({ checkingUser: false })
            })
        })
    }

    _createScript() {
        const script = document.createElement('script')
        script.src = 'https://apis.google.com/js/platform.js'
        script.async = true
        script.onload = this._initGapi
        document.body.appendChild(script)
    }

    _initGapi() {
        const g = window.gapi
        g.load('auth2', function () {
            g.auth2.init({
                client_id: '264938716570-2rmeiaf0081it3n3ktlg8qvs6dk5nu9v.apps.googleusercontent.com',
                scope: 'profile email openid'
            })
        })
    }

    _signInWithGoogle() {
        const ga = window.gapi.auth2.getAuthInstance()
        ga.signIn().then(
            googleUser => {
                this.props.signInWithGoogle(googleUser)
            },
            error => {
                console.log(error)
            }
        )
    }

    render() {
        if (this.props.user) {
            return <Redirect to='/clients' />
        }

        return (
            <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.14),_transparent_38%),linear-gradient(180deg,_#eff6ff_0%,_#f8fafc_38%,_#f8fafc_100%)] px-4 py-10 dark:bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.16),_transparent_34%),linear-gradient(180deg,_#020617_0%,_#020617_100%)]">
                <section className="w-full max-w-xl rounded-[32px] border border-slate-200/70 bg-white/90 p-8 shadow-soft backdrop-blur dark:border-slate-800 dark:bg-slate-950/85 sm:p-10">
                    <div className="flex justify-center">
                        <div className="inline-flex items-center gap-4 rounded-3xl bg-white px-5 py-4 shadow-sm dark:bg-slate-900">
                            <img src="/images/qr-logo.png" alt="Split 50-50" className="h-12 w-12" />
                            <div className="text-2xl font-extrabold tracking-tight text-slate-900 dark:text-white">Split 50-50</div>
                        </div>
                    </div>

                    <div className="mt-8 text-center">
                        <div className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-600 dark:text-sky-300">Secure access</div>
                        <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white sm:text-4xl">Admin Portal</h1>
                    </div>

                    <button
                        disabled={this.state.checkingUser || this.props.apiStatus !== 'API_IDLE'}
                        onClick={() => this._signInWithGoogle()}
                        className="mt-8 inline-flex w-full items-center justify-center rounded-2xl bg-[#1cd997] px-5 py-3.5 text-sm font-semibold text-slate-950 transition hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-70"
                    >
                        {this.state.checkingUser || this.props.apiStatus !== 'API_IDLE' ? 'Checking session...' : 'Sign in with Google'}
                    </button>
                </section>
            </div>
        )
    }
}

export default LoginPage
